export enum TipoUrlEnum {
	Relativa,
	Absoluta,
	Externa
}